import React, { useState, useEffect } from 'react'

// Material UI
import Divider from '@material-ui/core/Divider'
import List from '@material-ui/core/List'
import Grid from '@material-ui/core/Grid'

// Components
import IngredientsChoice from './IngredientsChoice'

// Redux
import { connect } from 'react-redux'

const Ingredients = ({ uid, addIngredients, menuData }) => {

    const [ingredients, setIngredients] = useState([])
    const styles = { alignItems: "baseline" }

    const { menu } = menuData

    useEffect(() => {
        setIngredients(menu.Ingredients.find(ingredient => ingredient.UID === uid))
    }, [menu, uid])

    function handleChange(ingredient, choice) {

        const { UID, Name, Price } = ingredient
        let ingredientToCart

        if (choice === "w") {
            ingredientToCart = { UID: UID, name: Name, price: 0, value: choice }
        } else {
            ingredientToCart = { UID: UID, name: Name, price: Price, value: choice }
        }

        addIngredients(ingredientToCart)
    }

    const replaceTheExtraWord = (ingredient) => {
        return ingredient.replace(/EXTRA/, "")
    }

    if (ingredients.length === 0) {
        return (<>Loading....</>)
    }

    return (
        <>
            <List>
                <h3>{ingredients.Name}</h3>
                <Divider />
                {ingredients.Ingredients.map((ingredient) =>
                    <div key={ingredient.UID}>
                        <Grid justify="space-between" container style={styles}>
                            <Grid item>
                                {replaceTheExtraWord(ingredient.Name)}
                            </Grid>
                            <Grid item>
                                <IngredientsChoice ingredient={ingredient} handleChange={handleChange} />
                            </Grid>
                        </Grid>
                        <Divider />
                    </div>
                )}
            </List>
        </>
    )
}

const mapStateToProps = state => {
    return {
        menuData: state.menuData
    }
}

export default connect(mapStateToProps)(Ingredients)